export enum SidebarTheme {
  LIGHT = 'light',
  MIXED = 'mixed',
}
